import React from 'react'
import classnames from 'classnames'
import GovActionsContentWrapper from './content-wrapper'
import './wrapper.css'

const GovActionsWrapper = ({ open, render, children }) => (
  <div
    className={classnames({
      'govListActions--wrapper': true,
      'govListActions--wrapper__open': open,
    })}>
    {render && render()}
    {open ? <GovActionsContentWrapper>{children}</GovActionsContentWrapper> : null}
  </div>
)

export default GovActionsWrapper



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/wrapper.jsx